var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
var VIDEO_EXTENSIONS = ['.mp4', '.mov', '.avi', '.webm', '.ogg', '.m4v'];
var isVideoFile = function (url) {
    if (!url)
        return false;
    return VIDEO_EXTENSIONS.some(function (ext) { return url.toLowerCase().includes(ext); });
};
export default function StripBgImageCarousel(props) {
    var bgWrapperRef = useRef(null);
    var fields = props.fields, children = props.children;
    var _a = useState(0), currentSlide = _a[0], setCurrentSlide = _a[1];
    var _b = useState(true), isPlaying = _b[0], setIsPlaying = _b[1];
    var _c = useState(0), progress = _c[0], setProgress = _c[1];
    var _d = useState(true), isVideoPlaying = _d[0], setIsVideoPlaying = _d[1];
    var _e = useState(0), sliderKey = _e[0], setSliderKey = _e[1];
    var _f = useState(false), jumpOutside = _f[0], setJumpOutside = _f[1];
    var videoRef = useRef(null);
    var sliderRef = useRef(null);
    var isVertical = fields.carouselType === "vertical";
    var focusableElements = useRef([]);
    var preloadImages = function (imageUrls) {
        imageUrls.forEach(function (url) {
            if (!url)
                return;
            var img = new Image();
            img.src = url;
        });
    };
    useEffect(function () {
        var preloadImgUrls = children && children.map(function (child) { return child.fields && child.fields.backgroundImage; });
        // preloadImages(preloadImgUrls);
    }, []);
    useEffect(function () {
        var resizeTimeout;
        var handleResize = function () {
            if (sliderRef.current && sliderRef.current.innerSlider) {
                var currentIndex_1 = currentSlide;
                clearTimeout(resizeTimeout);
                sliderRef.current.slickGoTo(currentIndex_1, false);
                sliderRef.current.innerSlider.onWindowResized();
                resizeTimeout = setTimeout(function () {
                    setSliderKey(function (prevKey) {
                        requestAnimationFrame(function () {
                            if (sliderRef.current) {
                                sliderRef.current.slickGoTo(currentIndex_1, false);
                            }
                        });
                        return prevKey + 1;
                    });
                }, 0);
            }
        };
        var debouncedResize = debounce(handleResize, 10);
        window.addEventListener('resize', debouncedResize);
        return function () {
            window.removeEventListener('resize', debouncedResize);
            clearTimeout(resizeTimeout);
        };
    }, [currentSlide]);
    function debounce(func, wait) {
        var timeout;
        return function executedFunction() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var later = function () {
                clearTimeout(timeout);
                func.apply(void 0, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    var extractNumber = function (str) {
        var match = str.match(/\d+$/);
        if (match) {
            return parseInt(match[0], 10);
        }
        else {
            return null;
        }
    };
    var settings = {
        //lazyLoad: "anticipated" as LazyLoadTypes,
        dots: false,
        infinite: true,
        autoplay: false,
        beforeChange: function (current, next) {
            setCurrentSlide(next);
            setProgress(0);
        },
        arrows: !isVertical,
        vertical: isVertical,
        verticalSwiping: isVertical,
        speed: 420,
        slidesToShow: 1,
        fade: true,
        slidesToScroll: 1,
        ltr: true
    };
    var toggleAutoplay = function () {
        setIsPlaying(!isPlaying);
    };
    var goToSlide = function (index) {
        setCurrentSlide(index);
        setProgress(0);
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(index);
        }
    };
    var backgroundImage = '';
    var currentChildFields = {};
    if (children && children.length > 0) {
        var currentChild = children[currentSlide];
        var childFields = currentChild.fields;
        if (childFields && childFields.backgroundImage) {
            backgroundImage = childFields.backgroundImage;
        }
        currentChildFields = childFields;
    }
    useEffect(function () {
        var timer;
        var interval;
        var startTime = Date.now();
        var duration = 5000;
        var isVideo = isVideoFile(currentChildFields.imageOrVideo);
        if (currentChildFields.slideDuration) {
            duration = parseInt(currentChildFields.slideDuration) * 1000;
        }
        if (isVertical || (!isVertical && !isVideo)) {
            if (isPlaying) {
                startTime = Date.now();
                interval = setInterval(function () {
                    var elapsedTime = Date.now() - startTime;
                    var percentage = (elapsedTime / duration) * 100;
                    if (percentage >= 100) {
                        setProgress(100);
                        startTime = Date.now();
                        setTimeout(function () {
                            var _a;
                            setProgress(0);
                            (_a = sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickNext();
                        }, 0);
                    }
                    else {
                        setProgress(percentage);
                    }
                }, 100);
            }
            else {
                setProgress(function (prevProgress) { return prevProgress; });
            }
        }
        else if (!isVertical && isVideo) {
            if (videoRef.current) {
                var videoElement_1 = videoRef.current;
                var updateProgress_1 = function () {
                    var percentage = (videoElement_1.currentTime / videoElement_1.duration) * 100;
                    setProgress(percentage);
                };
                if (isVideoPlaying) {
                    videoElement_1.play();
                }
                else {
                    videoElement_1.pause();
                }
                videoElement_1.addEventListener('timeupdate', updateProgress_1);
                var handleVideoEnded_1 = function () {
                    setProgress(100);
                    setTimeout(function () {
                        var _a;
                        setProgress(0);
                        (_a = sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickNext();
                    }, 0);
                };
                videoElement_1.addEventListener('ended', handleVideoEnded_1);
                return function () {
                    videoElement_1.removeEventListener('timeupdate', updateProgress_1);
                    videoElement_1.removeEventListener('ended', handleVideoEnded_1);
                };
            }
        }
        return function () {
            clearTimeout(timer);
            clearInterval(interval);
        };
    }, [currentSlide, isPlaying, currentChildFields, isVideoPlaying, isVertical]);
    useEffect(function () {
        setIsVideoPlaying(true);
        var backgroundImage = '';
        if (children && children.length > 0) {
            var currentChild = children[currentSlide];
            var childFields = currentChild.fields;
            if (childFields && childFields.backgroundImage) {
                backgroundImage = childFields.backgroundImage;
            }
        }
        backgroundImage && bgWrapperRef.current && (bgWrapperRef.current.style.backgroundImage = "url(\"".concat(backgroundImage, "\")"));
    }, [currentSlide]);
    useEffect(function () {
        focusableElements.current = [];
        var newFocusableElements = [];
        if (isVertical && Array.isArray(children) && children.length > 0) {
            children.forEach(function (child, index) {
                var liElement = document.getElementById("carousel-nav-item-".concat(index));
                if (liElement) {
                    newFocusableElements.push(liElement);
                }
                if (index === currentSlide && child.fields.centralButtonLabel) {
                    var centralButton = document.getElementById("central-button-".concat(index));
                    if (centralButton) {
                        newFocusableElements.push(centralButton);
                    }
                    var pauseButton = document.getElementById('pause-button');
                    if (pauseButton) {
                        newFocusableElements.push(pauseButton);
                    }
                }
                if (index === currentSlide && child.fields.firstButtonLabel) {
                    var firstButton = document.getElementById('first-bottom-button');
                    if (firstButton) {
                        newFocusableElements.push(firstButton);
                    }
                }
                if (index === currentSlide && child.fields.secondButtonLabel) {
                    var secondButton = document.getElementById('second-bottom-button');
                    if (secondButton) {
                        newFocusableElements.push(secondButton);
                    }
                }
            });
        }
        focusableElements.current = newFocusableElements;
    }, [children, currentSlide, isVertical]);
    var handleKeyDown = function (e, currentIndex) {
        var _a, _b;
        var count = focusableElements.current.length;
        if (e.key === 'Tab') {
            if (count === 0 || jumpOutside) {
                return;
            }
            var isAtFirst = currentIndex === 0;
            var isAtLast = currentIndex === count - 2;
            if (e.shiftKey) {
                if (isAtFirst) {
                    return;
                }
                else {
                    e.preventDefault();
                    (_a = focusableElements.current[currentIndex - 1]) === null || _a === void 0 ? void 0 : _a.focus();
                    setJumpOutside(false);
                }
            }
            else {
                if (isAtLast && focusableElements.current[currentIndex + 1].id === "second-bottom-button") {
                    setJumpOutside(true);
                    return;
                }
                else {
                    e.preventDefault();
                    (_b = focusableElements.current[currentIndex + 1]) === null || _b === void 0 ? void 0 : _b.focus();
                }
            }
        }
        if (e.key === 'Enter') {
            var currentElement = focusableElements.current[currentIndex];
            var slideIndex = extractNumber(currentElement.id);
            if (slideIndex !== null) {
                goToSlide(slideIndex);
            }
        }
    };
    var handlePlayPause = function () {
        var isVideo = isVideoFile(currentChildFields.imageOrVideo);
        if (isVideo && !isVertical) {
            if (videoRef.current) {
                if (isVideoPlaying) {
                    videoRef.current.pause();
                }
                else {
                    videoRef.current.play();
                }
                setIsVideoPlaying(!isVideoPlaying);
            }
        }
        else {
            toggleAutoplay();
        }
    };
    //  style={{ backgroundImage: `url(${backgroundImage})` }}
    return (React.createElement("div", __assign({ className: "strip spa-bg-image-carousel ".concat(fields.addOverlay ? ' bg-overlay ' : '')
            + fields.backgroundColor
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {}), { ref: bgWrapperRef }),
        children && children.map(function (child) { return child.fields && child.fields.backgroundImage
            && React.createElement("link", { rel: "preload", href: child.fields.backgroundImage, as: "image" }) || null; }),
        React.createElement("div", { className: "container" }, isVertical ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "carousel-wrapper vertical" },
                React.createElement("div", { className: "carousel-left" }, children && children.length > 0 && (React.createElement("ul", { className: "carousel-nav" }, children.map(function (child, index) {
                    var childFields = child.fields;
                    return (React.createElement("li", { key: index, id: "carousel-nav-item-".concat(index), onClick: function () { return goToSlide(index); }, className: index === currentSlide ? 'active' : '', tabIndex: index === 0 ? 0 : -1, onKeyDown: function (e) { return handleKeyDown(e, focusableElements.current.indexOf(e.currentTarget)); } }, childFields.titleTab && React.createElement("span", null, childFields.titleTab)));
                })))),
                React.createElement("div", { className: "carousel-center" },
                    React.createElement(Slider, __assign({ key: sliderKey, ref: sliderRef }, settings), children &&
                        children.length > 0 &&
                        children.map(function (child, index) {
                            var childFields = child.fields;
                            return (React.createElement("div", { key: index, className: "spa-bg-image-carousel__item" },
                                childFields.imageOrVideo && (React.createElement("div", { className: "img-container" }, isVideoFile(childFields.imageOrVideo) ? (React.createElement("video", { src: childFields.imageOrVideo, autoPlay: true, muted: true, loop: true })) : (React.createElement("img", { src: childFields.imageOrVideo, alt: childFields.imageOrVideo_description, title: childFields.imageOrVideo_title })))),
                                React.createElement("div", { className: "info-content" },
                                    childFields.titleTab && (React.createElement("div", { className: "tab-title" }, childFields.titleTab)),
                                    childFields.centralButtonLabel && (React.createElement("div", { className: "more mt-5" },
                                        React.createElement("a", { href: childFields.centralButtonLink, className: "btn btn-secondary border-white", title: childFields.centralButtonLabel, id: "central-button-".concat(index), tabIndex: index === currentSlide ? 0 : -1, onKeyDown: function (e) { return handleKeyDown(e, focusableElements.current.indexOf(e.currentTarget)); } }, childFields.centralButtonLabel))))));
                        }))),
                React.createElement("div", { className: "d-flex justify-content-between bottom-content" },
                    React.createElement("div", { className: "carousel-content" },
                        currentChildFields.ctaTitle && (React.createElement("p", { className: "cta-title" }, currentChildFields.ctaTitle)),
                        currentChildFields.ctaContent && (React.createElement("p", { className: "cta-content" }, currentChildFields.ctaContent))),
                    React.createElement("div", { className: "buttons" },
                        currentChildFields.firstButtonLabel && (React.createElement("a", { href: currentChildFields.firstButtonLink, className: "btn btn-outlined-invert", title: currentChildFields.firstButtonLabel, id: "first-bottom-button", onKeyDown: function (e) { return handleKeyDown(e, focusableElements.current.indexOf(e.currentTarget)); } }, currentChildFields.firstButtonLabel)),
                        currentChildFields.secondButtonLabel && (React.createElement("a", { href: currentChildFields.secondButtonLink, className: "btn btn-outlined-invert ms-2", title: currentChildFields.secondButtonLabel, id: "second-bottom-button", onKeyDown: function (e) { return handleKeyDown(e, focusableElements.current.indexOf(e.currentTarget)); } }, currentChildFields.secondButtonLabel))),
                    React.createElement("div", { className: "btn-controls d-flex" },
                        React.createElement("button", { id: "pause-button", className: "carousel-play-pause", onClick: toggleAutoplay, title: isPlaying ? "Pause carousel" : "Play carousel", onKeyDown: function (e) { return handleKeyDown(e, focusableElements.current.indexOf(e.currentTarget)); } }, isPlaying ? React.createElement("span", { className: "splide__toggle__pause" },
                            React.createElement("i", { className: "fa-regular fa-circle-pause" })) : React.createElement("span", { className: "splide__toggle__play" },
                            React.createElement("i", { className: "fa-regular fa-circle-play" })))))))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "carousel-wrapper horizontal" },
                React.createElement("div", { className: "carousel-progress" }, children && children.length > 0 && (React.createElement("ul", { className: "progress-bar" }, children.map(function (child, index) { return (React.createElement("li", { key: index, className: index === currentSlide ? 'active' : '', onClick: function () { return goToSlide(index); } },
                    React.createElement("div", { className: "progress-indicator", style: {
                            width: index === currentSlide ? "".concat(progress, "%") : '0%',
                            transition: 'width 0.1s linear',
                        } }))); })))),
                React.createElement("div", { className: "carousel-center h-100" },
                    React.createElement(Slider, __assign({ key: sliderKey, ref: sliderRef }, settings), children &&
                        children.length > 0 &&
                        children.map(function (child, index) {
                            var childFields = child.fields;
                            return (React.createElement("div", { key: index, className: "spa-bg-image-carousel__item" }, childFields.imageOrVideo && (React.createElement("div", { className: "img-container" },
                                isVideoFile(childFields.imageOrVideo) ? (React.createElement("video", { ref: index === currentSlide ? videoRef : null, src: childFields.imageOrVideo, autoPlay: true, muted: true })) : (React.createElement("img", { src: childFields.imageOrVideo, alt: childFields.imageOrVideo_description, title: childFields.imageOrVideo_title })),
                                React.createElement("button", { className: "carousel-play-pause", onClick: handlePlayPause, tabIndex: 0 }, isVideoFile(childFields.imageOrVideo) ? (isVideoPlaying ? (React.createElement("span", { className: "splide__toggle__pause" },
                                    React.createElement("i", { className: "fa-regular fa-circle-pause" }))) : (React.createElement("span", { className: "splide__toggle__play" },
                                    React.createElement("i", { className: "fa-regular fa-circle-play" })))) : (isPlaying ? (React.createElement("span", { className: "splide__toggle__pause" },
                                    React.createElement("i", { className: "fa-regular fa-circle-pause" }))) : (React.createElement("span", { className: "splide__toggle__play" },
                                    React.createElement("i", { className: "fa-regular fa-circle-play" })))))))));
                        }))),
                React.createElement("div", { className: "d-flex justify-content-between bottom-content" },
                    React.createElement("div", { className: "carousel-content" },
                        currentChildFields.ctaTitle && (React.createElement("p", { className: "cta-title" }, currentChildFields.ctaTitle)),
                        currentChildFields.ctaContent && (React.createElement("p", { className: "cta-content" }, currentChildFields.ctaContent))),
                    React.createElement("div", { className: "buttons" },
                        currentChildFields.firstButtonLabel && (React.createElement("a", { href: currentChildFields.firstButtonLink, className: "btn btn-outlined-invert", title: currentChildFields.firstButtonLabel, tabIndex: 0 }, currentChildFields.firstButtonLabel)),
                        currentChildFields.secondButtonLabel && (React.createElement("a", { href: currentChildFields.secondButtonLink, className: "btn btn-outlined-invert ms-2", title: currentChildFields.secondButtonLabel, tabIndex: 0 }, currentChildFields.secondButtonLabel))))))))));
}
